// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pn-0";
export var animationContainer = "_pn-1";
export var itemPrice = "_pn-a";
export var itemizedContent = "_pn-9";
export var itemizedHeader = "_pn-7";
export var itemizedRow = "_pn-8";
export var itemizedSection = "_pn-6";
export var modalContent = "_pn-2";
export var orderName = "_pn-3";
export var refundOption = "_pn-4";
export var refundOptionsContainer = "_pn-5";
export var shippingLabel = "_pn-b";
export var totalRow = "_pn-c";